import React, { useState } from 'react';
import { UserView, UserViewType } from '../../types/user';
import CustomerTable from './CustomerTable';
import UserViewNavigation from '../Common/UserViewNavigation';


interface CustomerListPageProps {
  branch: string | null;
}

const CustomerListPage: React.FC<CustomerListPageProps> = ({ branch }) => {
  const [selectedView, setSelectedView] = useState<UserView | null>(null);

  return (
    <>
      <UserViewNavigation 
        viewType={UserViewType.Customer}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
      />

      <div className="flex flex-col w-full h-full app-table-content">
        <CustomerTable
          view={selectedView}
          branch={branch}
        />
      </div>
    </>
  );
};

export default CustomerListPage;